import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="fetcher"
export default class extends Controller {
  static values = { url: String }
  connect() {
    fetch(this.urlValue, { headers: this.headers }).then((response) => response.text()).then((html) => this.element.innerHTML = html)
  }

  get headers() {
    return { "X-Requested-With": "XMLHttpRequest" };
  }
}
